export const PATCH_USER_JOURNALS = 'PATCH_USER_JOURNALS';
export const GET_USER_JOURNALS = 'GET_USER_JOURNALS';
export const CREATE_USER_JOURNALS = 'CREATE_USER_JOURNALS';
export const DELETE_USER_JOURNALS = 'DELETE_USER_JOURNALS';
